export const CrownIcon = (props) => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill={props.fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0563 2.32031L10.0157 4.19375L7.1001 0.304689C7.08837 0.289036 7.07315 0.276331 7.05566 0.26758C7.03817 0.258829 7.01887 0.254272 6.99931 0.254272C6.97975 0.254272 6.96046 0.258829 6.94297 0.26758C6.92548 0.276331 6.91026 0.289036 6.89853 0.304689L3.98447 4.19375L0.942283 2.32031C0.853221 2.26563 0.737596 2.33906 0.751658 2.44375L1.94541 11.5156C1.9626 11.6391 2.06885 11.7344 2.19541 11.7344H11.8063C11.9313 11.7344 12.0392 11.6406 12.0548 11.5156L13.2485 2.44375C13.261 2.33906 13.147 2.26563 13.0563 2.32031ZM7.0001 9.47188C5.24072 7.7125 7.0001 9.47188 5.24072 7.7125C5.24072 7.7125 5.24072 7.7125 6.42866 3.14294C8.18803 4.90232 9.70322 7.3125 9.70322 7.3125C9.70322 7.3125 8.75947 7.7125 7.0001 9.47188ZM6.42866 3.14294C5.24072 7.7125 5.24072 7.29531 5.24072 7.7125C5.24072 8.12813 6.58447 9.47188 7.0001 9.47188C8.75947 7.7125 9.70322 7.72969 9.70322 7.3125C9.70322 6.89688 8.18803 3.90076 6.42866 3.14294Z"
      fill={props.fill}
    />
  </svg>
);
